import { FaqSection } from '../interfaces/faq';

export const faqConfig: FaqSection[] = [
    {
        title: 'faq.sections.section-1.title',
        items: [
            {
                question: 'faq.items.item-1-1.question',
                answer: 'faq.items.item-1-1.answer'
            },
            {
                question: 'faq.items.item-1-2.question',
                answer: 'faq.items.item-1-2.answer'
            },
            {
                question: 'faq.items.item-1-3.question',
                answer: 'faq.items.item-1-3.answer'
            },
            {
                question: 'faq.items.item-1-4.question',
                answer: 'faq.items.item-1-4.answer'
            }
        ]
    },
    {
        title: 'faq.sections.section-2.title',
        items: [
            {
                question: 'faq.items.item-2-1.question',
                answer: 'faq.items.item-2-1.answer'
            },
            {
                question: 'faq.items.item-2-2.question',
                answer: 'faq.items.item-2-2.answer'
            },
            {
                question: 'faq.items.item-2-3.question',
                answer: 'faq.items.item-2-3.answer'
            },
            {
                question: 'faq.items.item-2-4.question',
                answer: 'faq.items.item-2-4.answer'
            },
            {
                question: 'faq.items.item-2-5.question',
                answer: 'faq.items.item-2-5.answer'
            },
            {
                question: 'faq.items.item-2-6.question',
                answer: 'faq.items.item-2-6.answer'
            }
        ]
    },
    {
        title: 'faq.sections.section-3.title',
        items: [
            {
                question: 'faq.items.item-3-1.question',
                answer: 'faq.items.item-3-1.answer'
            },
            {
                question: 'faq.items.item-3-2.question',
                answer: 'faq.items.item-3-2.answer'
            },
            {
                question: 'faq.items.item-3-3.question',
                answer: 'faq.items.item-3-3.answer'
            }
        ]
    },
    {
        title: 'faq.sections.section-4.title',
        items: [
            {
                question: 'faq.items.item-4-1.question',
                answer: 'faq.items.item-4-1.answer'
            },
            {
                question: 'faq.items.item-4-2.question',
                answer: 'faq.items.item-4-2.answer'
            },
            {
                question: 'faq.items.item-4-3.question',
                answer: 'faq.items.item-4-3.answer'
            },
            {
                question: 'faq.items.item-4-4.question',
                answer: 'faq.items.item-4-4.answer'
            },
            {
                question: 'faq.items.item-4-5.question',
                answer: 'faq.items.item-4-5.answer'
            }
        ]
    },
    {
        title: 'faq.sections.section-5.title',
        items: [
            {
                question: 'faq.items.item-5-1.question',
                answer: 'faq.items.item-5-1.answer'
            },
            {
                question: 'faq.items.item-5-2.question',
                answer: 'faq.items.item-5-2.answer'
            },
            {
                question: 'faq.items.item-5-3.question',
                answer: 'faq.items.item-5-3.answer'
            },
            {
                question: 'faq.items.item-5-4.question',
                answer: 'faq.items.item-5-4.answer'
            },
            {
                question: 'faq.items.item-5-5.question',
                answer: 'faq.items.item-5-5.answer'
            },
            {
                question: 'faq.items.item-5-6.question',
                answer: 'faq.items.item-5-6.answer'
            },
            {
                question: 'faq.items.item-5-7.question',
                answer: 'faq.items.item-5-7.answer'
            },
            {
                question: 'faq.items.item-5-8.question',
                answer: 'faq.items.item-5-8.answer'
            },
            {
                question: 'faq.items.item-5-9.question',
                answer: 'faq.items.item-5-9.answer'
            },
            {
                question: 'faq.items.item-5-10.question',
                answer: 'faq.items.item-5-10.answer'
            },
            {
                question: 'faq.items.item-5-11.question',
                answer: 'faq.items.item-5-11.answer'
            },
            {
                question: 'faq.items.item-5-12.question',
                answer: 'faq.items.item-5-12.answer'
            }
        ]
    },
    {
        title: 'faq.sections.section-6.title',
        items: [
            {
                question: 'faq.items.item-6-1.question',
                answer: 'faq.items.item-6-1.answer'
            },
            {
                question: 'faq.items.item-6-2.question',
                answer: 'faq.items.item-6-2.answer'
            },
            {
                question: 'faq.items.item-6-3.question',
                answer: 'faq.items.item-6-3.answer'
            },
            {
                question: 'faq.items.item-6-4.question',
                answer: 'faq.items.item-6-4.answer'
            },
            {
                question: 'faq.items.item-6-5.question',
                answer: 'faq.items.item-6-5.answer'
            },
            {
                question: 'faq.items.item-6-6.question',
                answer: 'faq.items.item-6-6.answer'
            }
        ]
    },
    {
        title: 'faq.sections.section-7.title',
        items: [
            {
                question: 'faq.items.item-7-1.question',
                answer: 'faq.items.item-7-1.answer'
            },
            {
                question: 'faq.items.item-7-2.question',
                answer: 'faq.items.item-7-2.answer'
            },
            {
                question: 'faq.items.item-7-3.question',
                answer: 'faq.items.item-7-3.answer'
            },
            {
                question: 'faq.items.item-7-4.question',
                answer: 'faq.items.item-7-4.answer'
            },
            {
                question: 'faq.items.item-7-5.question',
                answer: 'faq.items.item-7-5.answer'
            }
        ]
    }
];
